/* eslint-disable ember/no-classic-components */
import Component, { setComponentTemplate } from "@ember/component";
import { fn } from "@ember/helper";
import { computed } from "@ember/object";
import { reads } from "@ember/object/computed";
import { tagName } from "@ember-decorators/component";
import DButton from "discourse/components/d-button";
import discourseTag from "discourse/helpers/discourse-tag";
import { precompileTemplate } from "@ember/template-compilation";
const SelectedCollection = dt7948.c(class SelectedCollection extends Component {
  static {
    dt7948.g(this.prototype, "selectedTags", [reads("collection.content.selectedTags.[]")]);
  }
  #selectedTags = (dt7948.i(this, "selectedTags"), void 0);
  get tags() {
    if (!this.selectedTags) {
      return [];
    }
    let tags = this.selectedTags;
    if (tags.length >= 20 && this.selectKit.filter) {
      tags = tags.filter(t => t.includes(this.selectKit.filter));
    } else if (tags.length >= 20) {
      tags = tags.slice(0, 20);
    }
    return tags.map(selectedTag => {
      return {
        value: selectedTag,
        classNames: "selected-tag"
      };
    });
  }
  static {
    dt7948.n(this.prototype, "tags", [computed("selectedTags.[]", "selectKit.filter")]);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    {{#if this.tags}}\n      <div class=\"mini-tag-chooser-selected-collection selected-tags\">\n        {{#each this.tags as |tag|}}\n          <DButton @translatedTitle={{tag.value}} @icon=\"xmark\" @action={{fn this.selectKit.deselect tag.value}} tabindex=\"0\" class={{tag.classNames}}>\n            {{discourseTag tag.value noHref=true}}\n          </DButton>\n        {{/each}}\n      </div>\n    {{/if}}\n  ", {
      strictMode: true,
      scope: () => ({
        DButton,
        fn,
        discourseTag
      })
    }), this);
  }
}, [tagName("")]);
export default SelectedCollection;